module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABNQAAAAVCAMAAAC5bUO5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTOamX+amX+amX+amX+amX+amX+amX+amX+amX+GmReamX////vvx5e/GmO7BjvTavN1eEE8AAAAKdFJOUwD7p2a+hJZK8hZ8MzYyAAAAyElEQVR42u3byw6CMBRFUVSgIK///1uNUWeNoRJzwbWmnZ3BTkNodYXtDEXsxoYqEyBqiBqIGqKGqIkaP4gabKFPbTd8oWtTb0UglOZU3LRW0YB4UmnVLrYDQt7VstlapmnJHp4tB4TUZ5s23mWrliwHxJSp1jw+zJljuwG7itqzadmq2Q3YVdTGN1EDDhC16dW0SdSAA0TtE7sBQRW9KujsBgRVl0StthsQVCqJmt/UgLCa9U1rrAYEvqvVq76rdbV7GgAA/Icbn4XlaiM5fjgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/expand2.png
// module id = 564
// module chunks = 0